"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const sortable_1 = require("@dnd-kit/sortable");
const utilities_1 = require("@dnd-kit/utilities");
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const react_1 = require("react");
const index_1 = require("../../index");
const Icon_1 = __importDefault(require("../Icon/Icon"));
const utils_1 = require("./utils");
const DragAndDropItem = (props) => {
    const { itemId, children, editDeleteButtonSize, removeItem, itemIndex, hideIndex, backgroundColor, editItem, } = props;
    const { attributes, listeners, setNodeRef, transform, transition, isSorting, over, activeIndex, } = sortable_1.useSortable({ id: itemId });
    const { clone } = react_1.useContext(utils_1.DragAndDropCloneContext);
    const style = {
        // This checks makes items move after drop
        transform: isSorting ? undefined : utilities_1.CSS.Transform.toString(transform),
        transition,
    };
    const buttonClassName = classnames_1.default({
        'dnd-item-button': true,
        'dnd-item-button-dragging': clone,
    });
    const contentClassName = classnames_1.default({
        'dnd-item-content': true,
        'dnd-item-content-clone': clone,
        'dnd-item-content-dragging': activeIndex === itemIndex,
        'dnd-item-content-indicator-after': over && over.id === itemId &&
            activeIndex !== -1 && activeIndex < itemIndex,
        'dnd-item-content-indicator-before': over && over.id === itemId &&
            activeIndex !== -1 && activeIndex > itemIndex,
        [`dnd-item-content-background-${backgroundColor}`]: backgroundColor,
    });
    const itemNumberClassname = classnames_1.default({
        'dnd-item-number': true,
        'dnd-item-number-clone': clone,
    });
    const editRemoveButtonClassname = classnames_1.default({
        'dnd-item-edit-remove-button': true,
        'dnd-item-edit-remove-button-clone': clone,
    });
    return (React.createElement("li", { ref: setNodeRef, style: style, id: itemIndex.toString(), key: itemIndex, className: "dnd-item-container" },
        !hideIndex && React.createElement("div", { className: itemNumberClassname }, itemIndex + 1),
        React.createElement("div", { className: contentClassName },
            React.createElement("div", { className: "dnd-item-body" }, children),
            React.createElement("button", Object.assign({}, listeners, attributes, { className: buttonClassName, type: "button" }),
                React.createElement(Icon_1.default, { icon: "drag_and_drop" }))),
        removeItem && React.createElement("div", { className: editRemoveButtonClassname },
            React.createElement(index_1.IconButton, { icon: "delete", color: "secondary", size: editDeleteButtonSize !== null && editDeleteButtonSize !== void 0 ? editDeleteButtonSize : 40, onClick: removeItem })),
        editItem && React.createElement("div", { className: editRemoveButtonClassname },
            React.createElement(index_1.IconButton, { icon: "edit", color: "secondary", size: editDeleteButtonSize !== null && editDeleteButtonSize !== void 0 ? editDeleteButtonSize : 40, onClick: editItem }))));
};
exports.default = DragAndDropItem;
//# sourceMappingURL=DragAndDropItem.js.map